import { render, staticRenderFns } from "./PictureStatus.vue?vue&type=template&id=cdff6902&"
import script from "./PictureStatus.vue?vue&type=script&lang=js&"
export * from "./PictureStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports